import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiCheck } from 'react-icons/fi';
import './Navigation.css';

const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const steps = [
    { path: '/', label: 'Visit Date', number: 1 },
    { path: '/tickets', label: 'Tickets', number: 2 },
    { path: '/billing', label: 'Billing', number: 3 },
  ];

  const currentPath = location.pathname;
  const currentStepIndex = steps.findIndex(step => step.path === currentPath);

  const getStepStatus = (index) => {
    if (index < currentStepIndex) return 'completed';
    if (index === currentStepIndex) return 'active';
    return 'pending';
  };

  return (
    <nav className="navigation">
      <div className="navigation-container">
        {steps.map((step, index) => {
          const status = getStepStatus(index);
          const isClickable = index <= currentStepIndex;

          return (
            <div
              key={step.path}
              className={`nav-step ${status}`}
              onClick={() => isClickable && navigate(step.path)}
            >
              <div className="step-indicator">
                {status === 'completed' ? (
                  <div className="step-check">
                    <FiCheck />
                  </div>
                ) : (
                  <span className="step-number">{step.number}</span>
                )}
                {index < steps.length - 1 && (
                  <div className={`step-connector ${status === 'completed' ? 'completed' : ''}`}></div>
                )}
              </div>
              <span className="step-label">{step.label}</span>
            </div>
          );
        })}
      </div>
    </nav>
  );
};

export default Navigation;
